import type { RouteRecordRaw } from 'vue-router';

import { RouteName } from '@/core/router/RouteName';
import { Scope } from '@/plugins/authentication/lib/UserPermissions';

const requiresScopes: Scope[] = [Scope.CLIENTS_ACCESS_ALL];

const routes: readonly RouteRecordRaw[] = [
  {
    name: RouteName.CLIENTS,
    path: '/clients',
    component: () => import('@/domains/clients/views/ClientsSearchPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: RouteName.CLIENTS_SINGLE,
    redirect: { name: RouteName.CLIENTS_SINGLE_CONTRATS },
    path: '/clients/:id',
    component: () => import('@/domains/clients/views/ClientsSingle/ClientsSingleRootPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes,
    },
    props: true,
    children: [
      {
        name: RouteName.CLIENTS_SINGLE_CONTRATS,
        path: '',
        component: () => import('@/domains/clients/views/ClientsSingle/ClientsSingleContratsPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.CLIENTS_SINGLE_DOCUMENTS,
        path: 'documents',
        component: () => import('@/domains/clients/views/ClientsSingle/ClientsSingleDocumentsPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
    ],
  },
];

export default routes;
